module.exports = __webpack_public_path__ + "img/downloadPolicy.22faeef8.png";